import { render, staticRenderFns } from "./WebsitesAdd.vue?vue&type=template&id=74950a2e&"
import script from "./WebsitesAdd.vue?vue&type=script&lang=js&"
export * from "./WebsitesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports